import { render, staticRenderFns } from "./PorezCreate.vue?vue&type=template&id=231c1276&scoped=true&"
import script from "./PorezCreate.vue?vue&type=script&lang=js&"
export * from "./PorezCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c1276",
  null
  
)

export default component.exports